module.exports = __webpack_public_path__ + "static/media/star-b.faf4c023.svg";